import {
  chiseledStoneBricksIcon,
  clayIcon,
  cobbleStoneIcon,
  crackedStoneBricksIcon,
  dirtIcon,
  glassIcon,
  grassBlockIcon,
  mossBlockIcon,
  mossyCobblestoneIcon,
  mossyStoneBricksIcon,
  oakLogIcon,
  oakPlanksIcon,
  obsidianIcon,
  sandIcon,
  stoneBricksIcon,
  stoneIcon,
} from "../icons/icons";

import {
  dirtTexture,
  grassTopTexture,
  grassSideTexture,
  stoneTexture,
  oakPlanksTexture,
  oakLogTexture,
  oakLogTopTexture,
  cobbleStoneTexture,
  mossyCobblestoneTexture,
  mossTexture,
  glassTexture,
  obsidianTexture,
  stoneBrickTexture,
  mossyStoneBricksTexture,
  crackedStoneBricksTexture,
  chiseledStoneBricksTexture,
  sandTexture,
  clayTexture,
} from "../images/textures";
import {
  dirtPlace1,
  dirtPlace2,
  dirtPlace3,
  dirtPlace4,
  glassPlace1,
  glassPlace2,
  glassPlace3,
  grassPlace1,
  grassPlace2,
  grassPlace3,
  grassPlace4,
  mossPlace1,
  mossPlace2,
  mossPlace3,
  mossPlace4,
  mossPlace5,
  sandPlace1,
  sandPlace2,
  sandPlace3,
  sandPlace4,
  stonePlace1,
  stonePlace2,
  stonePlace3,
  stonePlace4,
  woodPlace1,
  woodPlace2,
  woodPlace3,
  woodPlace4,
} from "../sounds/sounds";

export const blocks = {
  dirt: {
    placed: [dirtPlace1, dirtPlace2, dirtPlace3, dirtPlace4],
    breaks: [dirtPlace1, dirtPlace2, dirtPlace3, dirtPlace4],
    right: dirtTexture,
    left: dirtTexture,
    top: dirtTexture,
    bottom: dirtTexture,
    front: dirtTexture,
    back: dirtTexture,
    image: dirtIcon,
    rotational: false,
  },
  grass_block: {
    placed: [grassPlace1, grassPlace2, grassPlace3, grassPlace4],
    breaks: [grassPlace1, grassPlace2, grassPlace3, grassPlace4],
    right: grassSideTexture,
    left: grassSideTexture,
    top: grassTopTexture,
    bottom: dirtTexture,
    front: grassSideTexture,
    back: grassSideTexture,
    image: grassBlockIcon,
    rotational: false,
  },
  moss: {
    placed: [mossPlace1, mossPlace2, mossPlace3, mossPlace4, mossPlace5],
    breaks: [mossPlace1, mossPlace2, mossPlace3, mossPlace4, mossPlace5],
    right: mossTexture,
    left: mossTexture,
    top: mossTexture,
    bottom: mossTexture,
    front: mossTexture,
    back: mossTexture,
    image: mossBlockIcon,
    rotational: false,
  },
  cobblestone: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: cobbleStoneTexture,
    left: cobbleStoneTexture,
    top: cobbleStoneTexture,
    bottom: cobbleStoneTexture,
    front: cobbleStoneTexture,
    back: cobbleStoneTexture,
    image: cobbleStoneIcon,
    rotational: false,
  },
  mossy_cobblestone: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: mossyCobblestoneTexture,
    left: mossyCobblestoneTexture,
    top: mossyCobblestoneTexture,
    bottom: mossyCobblestoneTexture,
    front: mossyCobblestoneTexture,
    back: mossyCobblestoneTexture,
    image: mossyCobblestoneIcon,
    rotational: false,
  },
  stone: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: stoneTexture,
    left: stoneTexture,
    top: stoneTexture,
    bottom: stoneTexture,
    front: stoneTexture,
    back: stoneTexture,
    image: stoneIcon,
    rotational: false,
  },
  stone_bricks: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: stoneBrickTexture,
    left: stoneBrickTexture,
    top: stoneBrickTexture,
    bottom: stoneBrickTexture,
    front: stoneBrickTexture,
    back: stoneBrickTexture,
    image: stoneBricksIcon,
    rotational: false,
  },
  mossy_stone_bricks: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: mossyStoneBricksTexture,
    left: mossyStoneBricksTexture,
    top: mossyStoneBricksTexture,
    bottom: mossyStoneBricksTexture,
    front: mossyStoneBricksTexture,
    back: mossyStoneBricksTexture,
    image: mossyStoneBricksIcon,
    rotational: false,
  },
  cracked_stone_bricks: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: crackedStoneBricksTexture,
    left: crackedStoneBricksTexture,
    top: crackedStoneBricksTexture,
    bottom: crackedStoneBricksTexture,
    front: crackedStoneBricksTexture,
    back: crackedStoneBricksTexture,
    image: crackedStoneBricksIcon,
    rotational: false,
  },
  chiseled_stone_bricks: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: chiseledStoneBricksTexture,
    left: chiseledStoneBricksTexture,
    top: chiseledStoneBricksTexture,
    bottom: chiseledStoneBricksTexture,
    front: chiseledStoneBricksTexture,
    back: chiseledStoneBricksTexture,
    image: chiseledStoneBricksIcon,
    rotational: false,
  },
  oak_plank: {
    placed: [woodPlace1, woodPlace2, woodPlace3, woodPlace4],
    breaks: [woodPlace1, woodPlace2, woodPlace3, woodPlace4],
    right: oakPlanksTexture,
    left: oakPlanksTexture,
    top: oakPlanksTexture,
    bottom: oakPlanksTexture,
    front: oakPlanksTexture,
    back: oakPlanksTexture,
    image: oakPlanksIcon,
    rotational: false,
  },
  oak_log: {
    placed: [woodPlace1, woodPlace2, woodPlace3, woodPlace4],
    breaks: [woodPlace1, woodPlace2, woodPlace3, woodPlace4],
    right: oakLogTexture,
    left: oakLogTexture,
    top: oakLogTopTexture,
    bottom: oakLogTopTexture,
    front: oakLogTexture,
    back: oakLogTexture,
    image: oakLogIcon,
    rotational: true,
  },

  sand: {
    placed: [sandPlace1, sandPlace2, sandPlace3, sandPlace4],
    breaks: [sandPlace1, sandPlace2, sandPlace3, sandPlace4],
    right: sandTexture,
    left: sandTexture,
    top: sandTexture,
    bottom: sandTexture,
    front: sandTexture,
    back: sandTexture,
    image: sandIcon,
    rotational: false,
  },

  clay: {
    placed: [dirtPlace1, dirtPlace2, dirtPlace3, dirtPlace4],
    breaks: [dirtPlace1, dirtPlace2, dirtPlace3, dirtPlace4],
    right: clayTexture,
    left: clayTexture,
    top: clayTexture,
    bottom: clayTexture,
    front: clayTexture,
    back: clayTexture,
    image: clayIcon,
    rotational: false,
  },

  glass: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [glassPlace1, glassPlace2, glassPlace3],
    right: glassTexture,
    left: glassTexture,
    top: glassTexture,
    bottom: glassTexture,
    front: glassTexture,
    back: glassTexture,
    image: glassIcon,
    rotational: false,
  },
  obsidian: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: obsidianTexture,
    left: obsidianTexture,
    top: obsidianTexture,
    bottom: obsidianTexture,
    front: obsidianTexture,
    back: obsidianTexture,
    image: obsidianIcon,
    rotational: false,
  },
};
